import { render } from "./Stake.vue?vue&type=template&id=c360b14e&scoped=true&ts=true"
import script from "./Stake.vue?vue&type=script&lang=ts"
export * from "./Stake.vue?vue&type=script&lang=ts"

import "./Stake.vue?vue&type=style&index=0&id=c360b14e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c360b14e"]])

export default __exports__